export const SET_QUEUED_TIMESTAMPS = "SET_QUEUED_TIMESTAMPS";
export const SET_AVAILABLE_WORKERS = "SET_AVAILABLE_WORKERS";

export const SetQueuedTimestamps = (value: number) => {
    return { type: SET_QUEUED_TIMESTAMPS, value };
};
export const SetAvailableWorkers = (value: number) => {
    return { type: SET_AVAILABLE_WORKERS, value };
};
